export const managementConstants = {
	BUILDINGS: 'buildings',
	FLOORS: 'floors',
	ROOMS: 'rooms',
	TABLES: 'tables',
	
	COMPANIES: 'companies',
	TEAMS: 'teams',
	JOBTITLES: 'jobtitles',
	
	SELECTED_TIMESLOTS: 'selected_timeslots',
	
	MANAGEMENT_SELECTED_START_DATE: 'management_selected_start_date',
	MANAGEMENT_SELECTED_END_DATE: 'management_selected_end_date',
	MANAGEMENT_CHART_DATE: 'management_chart_date'
};
